import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumCommentSchema } from './schemas';
import { forumCommentsQueryOptions } from './useForumComments';
import { forumPostQueryOptions } from './useForumPost';

type Payload = {
  content: string;
  forumPostId: number;
};

export const useCreateForumComment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: comment } = await fetchJson('/forum/comments', {
        method: 'POST',
        schema: apiResourceSchema(forumCommentSchema),
        body,
      });

      return comment;
    },
    onSuccess: (comment) => {
      queryClient.setQueryData(forumCommentsQueryOptions(comment.postId).queryKey, (comments) => [...(comments ?? []), comment]);
      queryClient.invalidateQueries(forumCommentsQueryOptions(comment.postId));
      queryClient.invalidateQueries(forumPostQueryOptions(comment.postId));
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.root });
    },
  });
};
